<template>
  <v-container v-once>
    <v-row align="center">
      <v-col
        v-if="value.title || value.paragraph"
        class="pr-xl-16"
        cols="12"
        lg="8"
        :xl="value.items.length > 3 ? 8 : 5"
      >
        <TitleParagraphCard :value="value" />
      </v-col>

      <v-col
        v-if="value.items && value.items.length"
        cols="12"
        :xl="value.items.length > 3 ? 12 : 7"
      >
        <v-row justify="center" justify-xl="start">
          <v-col
            v-for="item in value.items"
            :key="item.id"
            cols="12"
            sm="6"
            :lg="!(value.items.length % 2) ? 3 : 4"
            xl=""
          >
            <ServicesItem :value="item" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
